// DeleteConfirmationForm.tsx
import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';
import { formatMessage } from 'devextreme/localization';
import './DeleteConfirmationForm.css';

interface DeleteConfirmationFormProps {
    visible: boolean;
    onConfirm: () => void;
    onCancel: () => void;
    message: string;
}

const DeleteConfirmationForm: React.FC<DeleteConfirmationFormProps> = ({
    visible,
    onConfirm,
    onCancel,
    message
}) => {

    const renderContent = (): JSX.Element => (
        <div className="delete-confirmation-content">
            <div className="delete-confirmation-message">
                <p>{message}</p>
            </div>

            <div className="delete-confirmation-actions">
                <Button
                    text={formatMessage("DeleteConfirmationForm_Cancel")}
                    onClick={onCancel}
                    stylingMode="outlined"
                    type="normal"
                />
                <Button
                    text={formatMessage("DeleteConfirmationForm_Delete")}
                    onClick={onConfirm}
                    stylingMode="contained"
                    type="default"
                />
            </div>
        </div>
    );

    return (
        <Popup
            visible={visible}
            onHiding={onCancel}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title={formatMessage("DeleteConfirmationForm_Title")}
            width={450}
            height="auto"
            contentRender={renderContent}
        />
    );
};

export default DeleteConfirmationForm;